import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getData,
  postData,
  putData,
  deleteData,
} from "../../../../services/apiEndpoints";

export const createInvestmentThunk = createAsyncThunk(
  "investment/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await postData("/finance/investment/create-investment", payload);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const getInvestmentsThunk = createAsyncThunk(
  "investment/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getData("/finance/investment/get-investments");
      
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const getSingleInvestmentThunk = createAsyncThunk(
  "investment/getSingle",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getData(`/finance/investment/get-investment/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateInvestmentThunk = createAsyncThunk(
  "investment/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await putData(`/finance/investment/update/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteInvestmentThunk = createAsyncThunk(
  "investment/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteData(`/finance/investment/delete/${id}`);
      return { ...res, id };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteTransactionThunk = createAsyncThunk(
  "investment/deleteTransaction",
  async ({ investmentId, transactionItemId }, { rejectWithValue }) => {
    try {
      const res = await deleteData(
        `/finance/investment/${investmentId}/-deletetransaction/${transactionItemId}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);